import React, { Fragment } from "react";

export default function Spade() {
  return (
    <span
      style={{
        width: "35px",
        height: "35px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "100%",
        backgroundColor: "red"
      }}
    >
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="25px"
        height="25px"
        viewBox="0 0 1280.000000 1258.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <metadata>
          Created by potrace 1.15, written by Peter Selinger 2001-2017
        </metadata>
        <g
          transform="translate(0.000000,1258.000000) scale(0.100000,-0.100000)"
          fill="#000000"
          stroke="yellow"
        >
          <path
            d="M6295 12570 c-132 -29 -174 -56 -454 -290 -1331 -1112 -2746 -2473
-3717 -3575 -570 -647 -1039 -1259 -1346 -1756 -299 -484 -587 -1087 -667
-1399 -17 -63 -47 -203 -68 -310 l-38 -195 1 -255 c2 -260 3 -272 54 -533 36
-186 121 -422 228 -632 148 -292 365 -567 617 -781 557 -475 1319 -780 2225
-889 276 -34 746 -31 1050 6 100 12 360 58 372 65 4 3 8 2 8 -3 -1 -13 -273
-226 -660 -518 -485 -366 -584 -453 -702 -619 -129 -181 -156 -332 -94 -515
34 -98 63 -144 133 -214 67 -67 186 -131 273 -147 37 -7 1045 -9 2920 -8
l2865 3 59 23 c115 43 216 119 276 207 67 99 105 254 90 373 -28 221 -223 451
-660 774 -63 46 -187 138 -275 203 -215 159 -552 432 -543 441 2 1 41 -6 88
-16 401 -87 953 -104 1425 -44 407 52 883 179 1245 334 914 390 1507 1038
1721 1883 50 197 58 252 71 477 10 189 10 233 -6 370 -46 419 -182 843 -421
1315 -359 707 -956 1533 -1754 2430 -971 1090 -2331 2396 -3633 3486 -273 229
-308 254 -397 287 -73 26 -217 38 -286 22z"
          />
        </g>
      </svg>
    </span>
  );
}
